import { useTranslation } from 'react-i18next'
import { ContentLayout } from 'components/Layouts'
import { buildAbsoluteMedicareMyUrl } from 'utils/urls/buildAbsoluteMedicareMyUrl'
import { MsaContent } from 'containers/Claims/components/MsaContent'
import { BreadCrumb } from 'components/BreadCrumb/BreadCrumb'

const MsaDisclaimerBreadcrumb = () => {
  const { t } = useTranslation('msa')
  return (
      <BreadCrumb
        backButtonText={t('navigation.backToDisclaimer')}
        width="wide"
        navAriaLabel={t('navigation.backToDisclaimer')}
        backButtonLink="/claims/msa/disclaimer"
        siteActivityProps={{
          core: {
            component: 'Medicare Set Aside',
            coreClickData: {
              linkText: t('navigation.backToDisclaimer'),
              linkUrl: buildAbsoluteMedicareMyUrl('/claims/msa/disclaimer')
            },
            elementId: 'msa_backtodisclaimer_click'
          }
        }}
      />
  )
}

export const MsaMainPage = () => {
  const { t } = useTranslation('msa')

  return (
    <>
      <MsaDisclaimerBreadcrumb />
      <ContentLayout
        className="ds-u-padding-bottom--7"
        width="wide"
        heading={t('summary.heading')}
        withPrintButton
      >
        <div className="ds-l-container">
          <MsaContent />
        </div>
      </ContentLayout>
    </>
  )
}
